/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VatRateBase } from '../../models/vat-rate-base';
import { VatRateUpdatedModel } from '../../models/vat-rate-updated-model';

export interface PostApiVatrateV1Create$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: VatRateBase
}

export function postApiVatrateV1Create$Plain(http: HttpClient, rootUrl: string, params?: PostApiVatrateV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<VatRateUpdatedModel>> {
  const rb = new RequestBuilder(rootUrl, postApiVatrateV1Create$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VatRateUpdatedModel>;
    })
  );
}

postApiVatrateV1Create$Plain.PATH = '/private/v1/vat-rates/Create';
